import { Injectable, Inject, Injector } from '@angular/core';
import { take } from 'rxjs/operators';

export interface INotification {
  title: string;
  detail: string;
  type: ENotificationType;
}

export interface INotificactionConfig {
  closeOnClick?: number;            // tapToDismiss
  class?: string;                   // toastClass
  titleClass?: string;              // titleClass
  detailClass?: string;             // messageClass
  position?: ENotificationPosition; // positionClass
}

export enum ENotificationType {
  success,
  error,
  info,
  warning
}

export enum ENotificationPosition {
  top = 0,
  bottom = 1
}

@Injectable()
export class NotificationHandlerService {

  private readonly DEFAULT_LIB_CONFIG: Partial<any> = {
    timeOut: 10000,
    closeButton: true,
    enableHtml: false,
    toastClass: 'ngx-toastr',
    positionClass: 'toast-top-right',
    titleClass: 'toast-title',
    messageClass: 'toast-message',
    easing: 'ease-in',
    easeTime: 300
  };

  constructor(
    @Inject(Injector) private readonly injector: Injector
  ) { }

  public error(detail: string, title: string = 'Error', config?: INotificactionConfig, callback?: () => any) {
    const individualConfig = this.buildConfig(config);
    // this.toastrService.error(detail, title, individualConfig).onTap
    // .pipe(take(1))
    // .subscribe(() => callback ? callback() : null);
  }

  public show(
    type: ENotificationType,
    detail: string,
    title: string = 'Error',
    customConfig?: INotificactionConfig,
    callback?: () => any
  ): void {
    // TODO Se mantendrá pendiente por incompatibilidad de ngx-toastr con angular con ivy activado
    // let notification: ActiveToast<any>;
    const individualConfig = this.buildConfig(customConfig);
    switch (type) {
      case ENotificationType.success:
        // notification = this.toastrService.success(detail, title, individualConfig);
        break;
      case ENotificationType.error:
        // notification = this.toastrService.error(detail, title, individualConfig);
        break;
      case ENotificationType.info:
        // notification = this.toastrService.info(detail, title, individualConfig);
        break;
      case ENotificationType.warning:
        // notification = this.toastrService.warning(detail, title, individualConfig);
        break;
      default:
        // notification = this.toastrService.info(detail, title, individualConfig);
        break;
    }
    if (callback) {
      /* notification.onTap
      .pipe(take(1))
      .subscribe(() => callback()); */
    }
  }

  private buildConfig(config: INotificactionConfig): Partial<any> {
    if (!config) {
      return this.DEFAULT_LIB_CONFIG;
    }
    const individualConfig = Object.assign({}, this.DEFAULT_LIB_CONFIG);
    individualConfig.tapToDismiss = typeof config.closeOnClick === 'boolean' ? config.closeOnClick : this.DEFAULT_LIB_CONFIG.tapToDismiss;
    individualConfig.toastClass = config.class || individualConfig.toastClass;
    individualConfig.titleClass = config.titleClass || individualConfig.titleClass;
    individualConfig.messageClass = config.detailClass || individualConfig.messageClass;
    if (config.position) {
      switch (+config.position) {
        case ENotificationPosition.top:
          individualConfig.positionClass = 'toast-top-right';
          break;
        case ENotificationPosition.bottom:
          individualConfig.positionClass = 'toast-bottom-right';
          break;
      }
    }
    return individualConfig;
  }
}
